import { Injectable, inject, signal } from '@angular/core';
import { v4 as uuid } from 'uuid';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

interface Toast {
  id: string;
  message: string;
  type: ToastType;
  duration?: number;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private _toasts = signal<Toast[]>([]);
  toasts = this._toasts.asReadonly();

  private defaultDuration = 2000;

  show(
    message: string,
    type: ToastType = 'info',
    duration = this.defaultDuration,
  ) {
    const toast: Toast = {
      id: uuid(),
      message,
      type,
      duration,
    };
    this._toasts.update((toasts: any) => [...toasts, toast]);

    setTimeout(() => {
      this.remove(toast.id);
    }, duration);
  }

  success(message: string, duration?: number) {
    this.show(message, 'success', duration);
  }

  error(message: string, duration?: number) {
    this.show(message, 'error', duration);
  }

  warning(message: string, duration?: number) {
    this.show(message, 'warning', duration);
  }

  info(message: string, duration?: number) {
    this.show(message, 'info', duration);
  }

  remove(id: string) {
    this._toasts.update((toasts: any) =>
      toasts.filter((t: any) => t.id !== id),
    );
  }

  clear() {
    this._toasts.set([]);
  }
}
